// Unminified and customized version of assets/recipient-form.aio.min.js 

if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class extends HTMLElement {
      constructor() {
        super();

        this.checkboxInput = this.querySelector(
          `#Recipient-Checkbox-${this.dataset.sectionId}`
        );

        this.hiddenControlField = this.querySelector(
          `#Recipient-Control-${this.dataset.sectionId}`
        );

        this.emailInput = this.querySelector(
          `#Recipient-email-${this.dataset.sectionId}`
        );
        this.nameInput = this.querySelector(
          `#Recipient-name-${this.dataset.sectionId}`
        );
        this.messageInput = this.querySelector(
          `#Recipient-message-${this.dataset.sectionId}`
        );

        this.errorMessageWrapper = this.querySelector(
          '.product-form__recipient-error-message-wrapper'
        );
        this.errorMessageList =
          this.errorMessageWrapper?.querySelector('ul');
        this.errorMessage =
          this.errorMessageWrapper?.querySelector('.error-message');

        this.defaultErrorHeader = this.errorMessage?.innerText;

        // Enable checkbox for user interaction
        this.checkboxInput.disabled = false;

        this.addEventListener('change', this.onChange.bind(this));
      }

      onChange() {
        if (this.checkboxInput.checked) {
          // Enable Shopify recipient validation
          this.hiddenControlField.disabled = false;
          this.hiddenControlField.value = 'on';
        } else {
          // Disable recipient mode
          this.hiddenControlField.disabled = true;
          this.hiddenControlField.value = '';

          this.clearInputFields();
          this.clearErrorMessage();
        }
      }

      clearInputFields() {
        this.emailInput.value = '';
        this.nameInput.value = '';
        this.messageInput.value = '';
      }

      /**
       * This is meant to be called by THEME cart error handling,
       * not by this component itself.
       */
      displayErrorMessage(message, errors) {
        this.clearErrorMessage();
        this.errorMessageWrapper.removeAttribute('hidden');

        if (errors && typeof errors === 'object') {
          this.errorMessage.innerText = this.defaultErrorHeader;

          Object.entries(errors).forEach(([field, value]) => {
            const errorText = Array.isArray(value)
              ? value.join(', ')
              : value;

            const fieldSelector = `#Recipient-${field}-${this.dataset.sectionId}`;
            const errorId = `RecipientForm-${field}-error-${this.dataset.sectionId}`;

            // Summary list
            if (this.errorMessageList) {
              const li = document.createElement('li');
              const a = document.createElement('a');
              a.href = fieldSelector;
              a.innerText = errorText;
              li.appendChild(a);
              this.errorMessageList.appendChild(li);
            }

            // Inline error
            const errorContainer = this.querySelector(`#${errorId}`);
            const inlineError =
              errorContainer?.querySelector('.error-message');

            if (inlineError) {
              inlineError.innerText = `${errorText}.`;
              errorContainer.classList.remove('hidden');

              const input = this[`${field}Input`];
              input?.setAttribute('aria-invalid', 'true');
              input?.setAttribute('aria-describedby', errorId);
            }
          });

          return;
        }

        this.errorMessage.innerText = message;
      }

      clearErrorMessage() {
        this.errorMessageWrapper.setAttribute('hidden', '');

        if (this.errorMessageList) {
          this.errorMessageList.innerHTML = '';
        }

        this.querySelectorAll(
          '.recipient-fields .form__message'
        ).forEach((message) => {
          message.classList.add('hidden');
          const error = message.querySelector('.error-message');
          if (error) error.innerText = '';
        });

        [this.emailInput, this.messageInput, this.nameInput].forEach(
          (input) => {
            input.setAttribute('aria-invalid', 'false');
            input.removeAttribute('aria-describedby');
          }
        );
      }
    }
  );
}

// cart bridge to bypass theme's cart functionality, which is minified, and add bonus gift card when applicable
document.addEventListener('DOMContentLoaded', () => {
    const originalFetch = window.fetch;

    window.fetch = async function (...args) {

        const requestUrl = typeof args[0] === 'string' ? args[0] : args[0]?.url;

        const requestOptions = args[1];

        let addedVariantId = null;
        let addedQuantity = null;

        // Capture request payload BEFORE fetch
        if (requestUrl && requestUrl.includes('/cart/add.js') && requestOptions?.body) {
            
            try {
                if (requestOptions.body instanceof FormData) {
                    addedVariantId = requestOptions.body.get('id');
                    addedQuantity = requestOptions.body.get('quantity');
                } else {
                    const parsed = JSON.parse(requestOptions.body);

                    if (parsed.items?.length) {
                        addedVariantId = parsed.items[0].id;
                        addedQuantity = parsed.items[0].quantity;
                    }
                }

            } catch (e) {}
        } 

        const response = await originalFetch.apply(this, args);

        try {
            const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;

            // 422 handling (recipient errors)
            if (url && url.includes('/cart/add') && response.status === 422) {
                const clone = response.clone();
                const data = await clone.json();

                const recipientForm = document.querySelector('recipient-form');

                if (recipientForm && data?.errors) {
                    recipientForm.displayErrorMessage(data.message, data.errors);
                }

                return response;
            }

            // Success handling
            if (url && url.includes('/cart/add') && response.ok && !window._addingSecondary) {

                const bonusGiftCardId = window.BONUS_GIFT_CARD_MAP?.[addedVariantId]?.id;

                if (bonusGiftCardId) {

                    window._addingSecondary = true; // guard against infinite loop

                    await originalFetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            items: [
                                {
                                    id: bonusGiftCardId,
                                    quantity: addedQuantity
                                }
                            ]
                        })
                    });

                    window._addingSecondary = false;
                }
            }

        } catch (err) {
            console.warn('Cart bridge error', err);
            window._addingSecondary = false;
        }

        return response;
    };
});

// guards against recipient form submission if email field is unpopulated
document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-btn-addtocart]');
    if (!btn) return;

    const recipientForm = document.querySelector('recipient-form');
    if (!recipientForm) return;

    if (!recipientForm.checkboxInput.checked) return;

    const email = recipientForm.emailInput.value.trim();

    if (!email) {
        e.preventDefault();
        e.stopImmediatePropagation();

        recipientForm.displayErrorMessage('Validation failed', { email: ["can't be blank"] });
        recipientForm.scrollIntoView({ behavior: 'smooth', block: 'start' });

        return false;

    }

}, true);

